import { render, staticRenderFns } from "./orderForCheck.vue?vue&type=template&id=6d980aa1&scoped=true&"
import script from "./orderForCheck.vue?vue&type=script&lang=js&"
export * from "./orderForCheck.vue?vue&type=script&lang=js&"
import style0 from "./orderForCheck.vue?vue&type=style&index=0&id=6d980aa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d980aa1",
  null
  
)

export default component.exports